import Spinner from '@components/ui/Spinner';

export default function Loading() {
  return (
    <div className="fixed inset-x-0 top-0 z-[9999] flex h-screen min-w-full items-center justify-center bg-white">
      <Spinner />
    </div>
  );
}
